import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

// SLA template pages. They are Service's pages; the URLs stay under
// /settings/sla-templates, so the app mounts these as children of the
// `settings` route (src/app/register-settings.tsx). Paths are relative to it.
const SLATemplatesList = lazy(() =>
    import('./components/SLA').then((m) => ({
        default: m.SLATemplatesList,
    }))
)
const SLATemplatePage = lazy(() =>
    import('./components/SLA').then((m) => ({
        default: m.SLATemplatePage,
    }))
)

export const SLASettingsRoutes: RouteObject[] = [
    {
        path: 'sla-templates',
        element: <SLATemplatesList />,
    },
    {
        path: 'sla-templates/create',
        element: <SLATemplatePage />,
    },
    {
        path: 'sla-templates/:id/edit',
        element: <SLATemplatePage />,
    },
]
